const keys = {
  qr: ['qr'],
  qrLoginStatus: ['qrLoginStatus'],
}

export default keys
